export default {
    connectedLinkedInAccounts(state) {
        return state.connectedLinkedInAccounts;
    },
    authUrl(state) {
        return state.authUrl;
    }
}